import { useId } from 'react';
const sources = [
  { value: 'ampli_manual', label: 'Planejar pela Ampli', name: 'Ampli' },
  { value: 'sienge_business_budget', label: 'Usar Orçamento Empresarial Sienge', name: 'Orçamento Empresarial Sienge' },
];
const nameOf = source => sources.find(option => option.value === source)?.name || 'Não selecionada';

export default function SourceSelector({ options = [], selectedSource = null, pendingSelection = null, requestedSource = null, canEdit = false, busy = false, onRequestChange }) {
  const id = useId();
  return <section className="governance-section">
    <h2>Origem do planejamento</h2>
    <p>Fonte ativa: {nameOf(selectedSource)}</p>
    {pendingSelection && <p role="status">{nameOf(pendingSelection.selectedSource)}: aguardando aplicação</p>}
    <fieldset disabled={!canEdit || busy}>
      <legend>Onde deseja manter o planejamento?</legend>
      {sources.map(source => {
        const available = options.find(option => option.value === source.value)?.available === true;
        const reason = source.value === 'sienge_business_budget' ? 'Aguardando integração' : 'Fonte indisponível';
        return <div className="governance-card" key={source.value}>
          <label><input type="radio" name={`${id}-source`} checked={requestedSource === source.value} disabled={!available || !canEdit || busy} aria-describedby={!available ? `${id}-${source.value}` : undefined} onChange={() => { if (available && canEdit && !busy) onRequestChange?.(source.value); }} />{source.label}</label>
          {!available && <p id={`${id}-${source.value}`}>{reason}</p>}
        </div>;
      })}
    </fieldset>
    <p>A escolha será conferida em uma prévia antes da aplicação.</p>
  </section>;
}
